import { useEffect } from "react";

/**
 * Calls `handler` when a mousedown happens outside ALL the given refs.
 * Only active while `enabled` is true.
 *
 * @param {Array<React.RefObject>} refs  refs to elements that should be "inside"
 * @param {boolean} enabled
 * @param {() => void} handler
 */
export function useClickOutside(refs, enabled, handler) {
  useEffect(() => {
    if (!enabled) return;

    const onMouseDown = (e) => {
      const insideAny = refs.some(
        (ref) => ref.current && ref.current.contains(e.target)
      );
      if (!insideAny) handler();
    };

    document.addEventListener("mousedown", onMouseDown);
    return () => document.removeEventListener("mousedown", onMouseDown);
  }, [refs, enabled, handler]);
}
